module.exports = __webpack_public_path__ + "img/vault.cb56d232.png";